import { useSelector } from 'react-redux'
import { useCallback } from 'react'
import { EhrAppointmentKind } from '@src/types.ts'
import { clientConfigStoreStateSelector } from '@selectors/app.ts'

export const useVideoCallDurations = () => {
  const clientConfig = useSelector(clientConfigStoreStateSelector)

  const getAppointmentDuration = useCallback(
    (kind: EhrAppointmentKind | undefined | null) => {
      if (!kind) {
        return 0
      }

      return (
        clientConfig.appointmentKinds.find((appointmentKind) => appointmentKind.key === kind)
          ?.duration || 0
      )
    },
    [clientConfig],
  )

  return { getAppointmentDuration }
}
